import React, { useEffect, useState } from 'react';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import SelectTwo, { SelectTwoMapperOptions } from '../../../../components/SelectTwo';
import { ResponseType } from '../../../../app/models/ResponseType';
import { QuestionDataForm } from '../../../../app/models/Question';
import { InputResponseType } from '../../../../app/shared/enums';
import InputButtonFile from '../../../../components/inputs/InputButtonFile';

interface GeneralProps {
    questionForm: QuestionDataForm;
    setQuestionForm: (QuestionForm: QuestionDataForm) => void;
    responseTypes: ResponseType[];
    errorFields?: any;
}

const QuestionForm = ({
    questionForm,
    setQuestionForm,
    responseTypes,
    errorFields
}: GeneralProps) => {
    
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();
    
    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const [image, setImage] = useState(
        questionForm.support_image
            ? questionForm.support_image
            : ''
    );

    const handleChange = (
        event: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        const { name, value } = event.target;
        setQuestionForm({ ...questionForm, [name]: value });
    };

    const handleChangeSelectTwo = (name: string, value: number | string | null) => {
        const obj = { [name]: value };
        setQuestionForm({ ...questionForm, ...obj });
    };
    
    const handleCheckChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { checked } = event.target;
        const obj = { [event.target.name]: checked };

        setQuestionForm({ ...questionForm, ...obj });
    };

    const dataOnChangeImages = (e: any) => {
        const selectedFile = e.target.files[0];
        console.log(selectedFile);
        if (selectedFile) {
            setImage(URL.createObjectURL(selectedFile));
            setQuestionForm({
                ...questionForm,
                [e.target.name]: selectedFile
            });
        }
    };

    if (!questionForm) return null;

    return (
        <>
           <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Pregunta</label>

                    <input
                        className={`form-control ${fieldHasError('title')}`}
                        type="text"
                        name="question_text"
                        id="question_text"
                        value={questionForm.question_text}
                        onChange={handleChange}
                        placeholder="Ingrese pregunta a realizar"
                        onFocus={() => onFocusRemove('question_text')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('question_text')}
                    </div>
                </div>
            </div>
            
            <div className="mb-2 row">
                <div className="col-md-12">
                    <label className="col-form-label">Tipo de respuesta</label>
                    <SelectTwo
                        name="response_type"
                        id="response_type"
                        inputValue={questionForm.response_type}
                        options={SelectTwoMapperOptions(responseTypes, 'id', ['name'])}
                        hasError={fieldHasError('response_type') !== ''}
                        onChange={(value: any) => handleChangeSelectTwo('response_type', value?.value)}
                        placeholder={'Seleccione opción'}
                        onFocus={() => onFocusRemove('response_type')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('response_type')}
                    </div>
                </div>
            </div>
            <div className="mb-2 row">
                
                <div className="col-12">
                    <label htmlFor="is_required" className="col-form-label">
                        Respuesta requerida
                    </label>
                    <div className="square-switch d-flex  form-check form-switch">
                        <input
                            type="checkbox"
                            name="is_required"
                            id="is_required"
                            className={`form-check-input ${
                                questionForm.is_required ? 'active' : ''
                            }`}
                            checked={questionForm.is_required}
                            onChange={handleCheckChange}
                        />
                        {fieldErrorMessage('is_required')}
                    </div>
                </div>
                
                { questionForm.response_type !== InputResponseType.FILE && <div className="col-12">
                    <label htmlFor="include_image" className="col-form-label">
                        Incluir Imagen
                    </label>
                    <div className="square-switch d-flex  form-check form-switch">
                        <input
                            type="checkbox"
                            name="include_image"
                            id="include_image"
                            className={`form-check-input ${
                                questionForm.include_image ? 'active' : ''
                            }`}
                            checked={questionForm.include_image}
                            onChange={handleCheckChange}
                        />
                        {fieldErrorMessage('include_image')}
                    </div>
                </div> }

                <div className="col-12">
                    <label htmlFor="include_comment" className="col-form-label">
                        Incluir Observaciones
                    </label>
                    <div className="square-switch d-flex  form-check form-switch">
                        <input
                            type="checkbox"
                            name="include_comment"
                            id="include_comment"
                            className={`form-check-input ${
                                questionForm.include_comment ? 'active' : ''
                            }`}
                            checked={questionForm.include_comment}
                            onChange={handleCheckChange}
                        />
                        {fieldErrorMessage('include_comment')}
                    </div>
                </div>

                <div className="col-12">
                    <label htmlFor="include_support_image" className="col-form-label">
                        Incluir Imagen Referencia a la Pregunta
                    </label>
                    <div className="square-switch d-flex  form-check form-switch">
                        <input
                            type="checkbox"
                            name="include_support_image"
                            id="include_support_image"
                            className={`form-check-input ${
                                questionForm.include_support_image ? 'active' : ''
                            }`}
                            checked={questionForm.include_support_image}
                            onChange={handleCheckChange}
                        />
                        {fieldErrorMessage('include_support_image')}
                    </div>
                </div>

                { questionForm.include_support_image && <div className="col-12">

                    <div className="col-md-12 text-center d-flex">
                        <div className="mx-auto mb-3">
                            <label htmlFor="support_image">
                                { image 
                                ? <img
                                        src={
                                            typeof image === 'string' && image !== ''
                                                ? image
                                                : window.URL.createObjectURL(image as Blob)
                                        }
                                        className="pointer bg-white"
                                        style={{
                                            width: '250px',
                                            height: '200px',
                                            objectFit: 'contain',
                                            border: '2px solid #ccc',
                                            display: 'block',     // 🔹 Permite centrar con margin
                                            margin: '0 auto',     // 🔹 Centra horizontalmente
                                            backgroundColor: '#fff',
                                        }}
                                    /> 
                                : 
                                <div className="pointer">
                                    <button
                                        type="button"
                                        className='form-control btn mdi fs-5 btn-primary cursor-not-allowed'
                                        disabled={true}    
                                        >
                                        <i className="fa fa-save" /> Cargar Imagen Referencia
                                    </button>
                                </div>
                                
                            }
                            </label>
                        </div>
                        <input
                            type="file"
                            className="custom-file-input"
                            style={{ height: '0px', width: '0px' }}
                            id="support_image"
                            name="support_image"
                            onChange={dataOnChangeImages}
                        />
                    </div>
                </div> }

            </div>
            
        </>
    );
};

export default QuestionForm;
